import {Component} from '@angular/core';
import {dateInscription} from '../../../environments/environment';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-waiting-screen',
    templateUrl: './waiting-screen.component.html',
    styleUrls: ['./waiting-screen.component.scss'],
    imports: [DatePipe]
})
export class WaitingScreenComponent {

    dateAfterLimit = new Date(dateInscription.limitDate);

    currentYear = new Date().getFullYear();

    constructor() {
        this.dateAfterLimit.setDate(this.dateAfterLimit.getDate());
    }
}
